const fmt = (iso) =>
  new Date(iso).toLocaleString("fr-CH", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

const COLS = ["Date", "Nom", "Entreprise", "Téléphone", "Email", "Service", "Message"];

export const QuotesTable = ({ quotes }) => {
  if (!quotes.length)
    return (
      <div data-testid="admin-empty-state" className="rounded-xl border border-dashed border-cs-navy/20 bg-white p-12 text-center text-cs-ink/60">
        Aucune demande de devis pour le moment.
      </div>
    );

  return (
    <div className="overflow-x-auto rounded-xl border border-cs-navy/10 bg-white">
      <table data-testid="admin-quotes-table" className="w-full min-w-[900px] text-left text-sm">
        <thead className="bg-cs-navy/[0.04] text-xs uppercase tracking-wider text-cs-navy/70">
          <tr>{COLS.map((c) => <th key={c} className="px-4 py-3 font-semibold">{c}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-cs-navy/5">
          {quotes.map((q) => (
            <tr key={q.id} data-testid={`admin-quote-row-${q.id}`} className="align-top hover:bg-cs-grey/60">
              <td className="whitespace-nowrap px-4 py-3.5 text-cs-ink/60">{fmt(q.created_at)}</td>
              <td className="px-4 py-3.5 font-semibold text-cs-navy">{q.nom}</td>
              <td className="px-4 py-3.5">{q.entreprise || "—"}</td>
              <td className="whitespace-nowrap px-4 py-3.5"><a href={`tel:${q.telephone}`} className="hover:underline">{q.telephone}</a></td>
              <td className="px-4 py-3.5"><a href={`mailto:${q.email}`} className="hover:underline">{q.email}</a></td>
              <td className="px-4 py-3.5">
                {q.service ? <span className="inline-block rounded-full bg-cs-yellow/20 px-2.5 py-1 text-xs font-semibold text-cs-navy">{q.service}</span> : "—"}
              </td>
              <td className="max-w-xs whitespace-pre-line px-4 py-3.5 text-cs-ink/80">{q.message || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
